

function confirmSiteDeletion(siteNameToDelete, siteId) {



    swal({
        title: "Are you sure?",
        text: "Removing the site will deactive all screens and all data will be unavailable.",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn-danger",
        confirmButtonText: "Yes, remove " + siteNameToDelete,
        closeOnConfirm: false
    },
        function () {

            swal({
                title: "Deletion security",
                text: "Write '" + siteNameToDelete + "'",
                type: "input",
                showCancelButton: true,
                closeOnConfirm: false,
                inputPlaceholder: "Site name"
            }, function (inputValue) {
                if (inputValue === false) return false;
                if (inputValue === "") {
                    //swal.showInputError("You need to write something!");
                    return false
                }

                if (inputValue == siteNameToDelete) {
                    DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnSiteDeleteConfirmed', siteId);
                    swal("Removed.", siteNameToDelete + " was removed", "success");
                }

            });
           
           
        });
}

function templatesSavedSuccess(arg) {
    swal({
        title: "Saved",
        text: "Templates saved",
        type: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500
    });

}

function defaultMessagesSavedSuccess(arg) {
    swal({
        title: "Saved",
        text: "Default reply saved",
        type: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500
    });

}

function confirmSetDefaults(arg0, arg1) {

    swal({
        title: "Are you sure?",
        text: "Setting default templates will undo all changes you made to the templates, this cannot be undone.",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes, set defaults",
        closeOnConfirm: false
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnDefaultTemplatesConfirmed', 0);
        });
}

function confirmSaveTemplates(siteName, siteId) {
    swal({
        title: "Are you sure?",
        text: "Saving the templates will apply immediately.",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes, save",
        closeOnConfirm: false
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnSaveTemplatesConfirmed', siteName, siteId);
        });
}


function toggleEditGuardDeviceDialog(guardDeviceId) {
    $('#editModalGuardDevice').modal('toggle');
    return 1;
}

function closeEditGuardDeviceDialog() {
    $('#editModalGuardDevice').modal('hide');
    return 1;
}

function confirmDeleteDevice(guardDeviceId) {

    swal({
        title: "Are you sure?",
        text: "If you remove this device, it wont be able to authenticate anymore.",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes, delete.",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnDeleteGuardDeviceConfirmed', guardDeviceId);
           

        });
}

function toggleEditIpNumberDialog(ipNumberId) {
    $('#editModalIpNumber').modal('toggle');
    return 1;
}

function closeEditIpNumberDialog() {
    $('#editModalIpNumber').modal('hide');
    return 1;
}

function confirmDeleteIpNumber(ipNumberId) {

    swal({
        title: "Are you sure?",
        text: "If you remove this IP, it wont be able to authenticate anymore.",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes, delete.",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnDeleteSafeIpNumberConfirmed', ipNumberId);


        });
}




//Not in manage page

function ForceDefaultTextSwitchInAccountPage(val) {
    document.getElementById("adminStartTextSwitch").checked = val;
}

function replaceStartTextURLs(message) {
    if (!message) return;

    var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
    return message.replace(urlRegex, function (url) {
        var hyperlink = url;
        if (!hyperlink.match('^https?:\/\/')) {
            hyperlink = 'http://' + hyperlink;
        }
        return '<a href="' + hyperlink + '" target="_blank" rel="noopener noreferrer">' + url + '</a>'
    });
}

function DisplayUserAdminStartCustomText(text) {

    try {
        if (text != null) {
            var htmlToDisplay = text.replace(/\n/g, "<br />");
            document.getElementById("customAdminStartMessageDisplay").innerHTML = replaceStartTextURLs(htmlToDisplay);
        }
    } catch (e) {
        console.log(e);
    }

}

//

function siteMemberInviteSentSuccess(arg) {
    swal({
        title: "Sent",
        text: "Invite sent",
        type: "success",
        showCancelButton: false,
        showConfirmButton: false,
        timer: 1500
    });

}

function confirmDeleteSiteMember(siteMemberId) {

    swal({
        title: "Are you sure?",
        text: "If you remove this user they wont be able to access this location anymore. To get access again they will need to accept an invite again.",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-warning",
        confirmButtonText: "Yes, remove.",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnDeleteSiteMemberConfirmed', siteMemberId);


        });
}

function toggleEditSiteMemberDialog(siteMemberId) {
    $('#editModalSiteMember').modal('toggle');
    return 1;
}

function closeEditSiteMemberDialog() {
    $('#editModalSiteMember').modal('hide');
    return 1;
}


            //

function toggleEditRoleDialog() {
    $('#editModalRole').modal('toggle');
    return 1;
}

function closeEditRoleDialog() {
    $('#editModalRole').modal('hide');
    return 1;
}
//

function StartCreateNewScreen(siteId) {
    swal({
        title: "Are you sure?",
        text: "",
        type: "info",
        showCancelButton: true,
        confirmButtonClass: "btn-info",
        confirmButtonText: "Yes",
        closeOnConfirm: true
    },
        function () {
            DotNet.invokeMethodAsync('VisitForm.Client.UI.Common', 'OnCreateNewScreenConfirmed', siteId);
        });
}